var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('button',{on:{"click":_vm.nextScene}},[_vm._v("Volgende Scene")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }